import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
var tableDomUnassigned = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

var OFFERS_COLUMN_INDEX = {
    Name: 0,
    Currency: 1
}

var FILTER_DELIM = '-delim-';
var btnCancelSearchId = 'btnCancelSearch';

export interface GamesSelectionPageOptions extends PageOptionsBase {
    dataSwitch: string;
    urlList: string;
    urlDetail: string;
    urlPost: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
        AddLink: string;
    }
}

export class GamesSelectionPage extends PageBase<GamesSelectionPageOptions> {

    protected static rolesInit: string;
    protected static msApi: MultiSelectApi;

    protected _tableOptions: DatatableOptions;
    protected _table: Datatable;
    protected _tableId: string;

    protected _form: JQuery;

    constructor(options: GamesSelectionPageOptions) {
        super(options);

        this.formSubmit = this.formSubmit.bind(this);
    }

    init(): void {
        GamesSelectionPage.msApi = new MultiSelectApi('roles');
        GamesSelectionPage.rolesInit = GamesSelectionPage.msApi.getSelectionValues();
        this._form = Utils.getJQueryById("form" + this._tableId);

        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        this._table = new Datatable(this._tableId, this._tableOptions);

        this._form.on('submit', this.formSubmit);
    }

    public static showForm(field: string, focusField: string) {
        $(".multi-hide").hide();
        $(".multi-show").show();

        $(".multi-show").closest(".form-group").removeClass("gray");

        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).hide();
        $(frm).show();

        $(label).closest(".form-group").addClass("gray");

        if (focusField) {
            $('#' + focusField).focus();
        }
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    protected showHideSelectAllCheckbox(selectAllButton: string, checkboxesIdentifier: string): void {
        let selectAllCheckbox = Utils.getJQueryById(selectAllButton)[0];
        if (Utils.isNullOrUndefined(selectAllCheckbox))
            return;
        var checkboxes = $(checkboxesIdentifier);
        if (checkboxes.length === 0) {
            (<HTMLInputElement>selectAllCheckbox).hidden = true;
        } else {
            (<HTMLInputElement>selectAllCheckbox).hidden = false;
        }
    }

    public static hideForm(field: string) {
        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).show();
        $(frm).hide();

        GamesSelectionPage.msApi.setSelectionValues(GamesSelectionPage.rolesInit);

        $(label).closest(".form-group").removeClass("gray");
    }
}

export class AssignedGamesSelectionPage extends GamesSelectionPage {

    private _chckAllGames: JQuery;

    constructor(options: GamesSelectionPageOptions) {
        super(options);

        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.removeSelectedGames = this.removeSelectedGames.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        this.drawCallback = this.drawCallback.bind(this);

        window['setGamesSelectAllCheckbox'] = this.setGamesSelectAllCheckbox;

        if (options.dataSwitch === "assignedGames") {
            this._tableId = "tableAssignedGames";
            this._tableOptions = {
                url: this._options.urlList,
                dom: tableDom,
                rowId: 'betSettingId',
                autoWidth: true,
                ordering: true,
                columns: [
                    {
                        data: 'BetSettingId',
                        sortable: false,
                        render: (data: any, type: any, rowData: any) =>
                            (`<input id='chckbx${rowData.BetSettingId}' name='selectedGame' value='${rowData.BetSettingId}' type='checkbox' onClick="setGamesSelectAllCheckbox()" />`)
                    },
                    {
                        data: "GameName",
                        sortable: true,
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameName${rowData.BetSettingId}'>${data}</span>`)
                    },
                    {
                        data: "CurrencyCode",
                        sortable: true,
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameCurrency${rowData.BetSettingId}'>${data}</span>`)
                    },
                    {
                        data: "ValuePerSpin",
                        sortable: true,
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnValuePerSpin${rowData.BetSettingId}'>${data}</span>`)
                    }
                ],
                order: [[1, "asc"]],
                callbacks: {
                    preDrawCallback: this.preDrawCallback,
                    drawCallback: this.drawCallback
                }
            };
        }

    }

    init(): void {
        GamesSelectionPage.msApi = new MultiSelectApi('roles');
        GamesSelectionPage.rolesInit = GamesSelectionPage.msApi.getSelectionValues();
        const btnRemoveMulti = Utils.getJQueryById("btnRemoveSelected");
        this._form = Utils.getJQueryById("form" + this._tableId);
        btnRemoveMulti.on("click", this.removeSelectedGames);
        this._chckAllGames = Utils.getJQueryById("gamesSelectAll");
        this._chckAllGames.on("change", this.checkBoxAll);
        // == create 'new Datatable' instance
        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        super.init();
    }

    private setGamesSelectAllCheckbox(): void {
        var checkboxes = $("input[name='selectedGame']");
        let gamesSelectAll = Utils.getJQueryById("gamesSelectAll")[0];
        if (Utils.isNullOrUndefined(gamesSelectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }
        (<HTMLInputElement>gamesSelectAll).checked = allCheckboxesChecked;
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedGame']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._chckAllGames[0]).checked;
        }
    }

    private removeSelectedGames(e: JQueryEventObject): void {
        e.preventDefault();
        var urlPost = this._options.urlPost;
        var table = this._table;
        var unassignedGamesTable = Utils.getJQueryById('tableUnassignedGames').DataTable();
        var ids = $("input[name='selectedGame']:checked").map(function () {
            return $(this).val();
        });
        var statusMessage = Utils.getJQueryById("statusMessageWrapper");
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { betSettingIds: ids.get() },
            success: function (data) {
                statusMessage.html(data);
                StatusMessageHelper.initValidator();
                StatusMessageHelper.initSatusMessage();
                table.draw();
                unassignedGamesTable.draw();
            }
        });
    }

    private preDrawCallback(datatable: DatatableApi): any {
        (<HTMLInputElement>this._chckAllGames[0]).checked = false;
        this.showHideSelectAllCheckboxes();
        return true;
    }

    private drawCallback(datatable: DatatableApi): any {
        this.showHideSelectAllCheckboxes();
    }

    private showHideSelectAllCheckboxes(): void {
        this.showHideSelectAllCheckbox("gamesSelectAll", "input[name='selectedGame']");
    }

}

export class UnassignedGamesSelectionPage extends GamesSelectionPage {

    private _filterGame: MultiSelectApi;
    private _filterCurrency: MultiSelectApi;
    private _optionUrl: string;
    private _btnCancelSearch: JQuery;

    constructor(options: GamesSelectionPageOptions) {
        super(options);
        this._optionUrl = options.urlDetail;
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.addGame = this.addGame.bind(this);

        window['addGameClick'] = this.addGame;

        if (options.dataSwitch === "unassignedGames") {
            this._tableId = "tableUnassignedGames";
            this._tableOptions = {
                url: this._options.urlList,
                dom: tableDomUnassigned,
                rowId: 'configurationId',
                autoWidth: true,
                ordering: true,
                columns: [
                    {
                        data: "GameName",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnUnassignedGameName${rowData.ConfigurationId}'>${data}</span>`)
                    },
                    {
                        data: "CurrencyCode",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnUnassignedGameCurrency${rowData.ConfigurationId}'>${data}</span>`)
                    },
                    {
                        data: "ValuesPerSpin",
                        sortable: false,
                        render: (data: any, type: any, rowData: any) => {
                            var option = `<select id='comboSpinValue${rowData.ConfigurationId}'>`;
                            data.forEach((value: any) => {
                                option += `<option value="${value.Key}">${value.BetValue}</option>`;
                            });
                            option += '</select>';
                            return option;
                        }
                    },
                    {
                        data: '',
                        sortable: false,
                        render: (data: any, type: any, rowData: any) => {
                            if (rowData.AllowAdd){
                                return (`<a id='lnkDetail${rowData.ConfigurationId}' href='#' onClick='addGameClick(${rowData.ConfigurationId});'>${options.localizer.AddLink}</a>`);
                            } else {
                                return (`
                                    <a id='lnkDetail${rowData.ConfigurationId}'
                                       href='#'
                                       onClick='event.preventDefault();'
                                       style='color: gray; cursor: not-allowed; pointer-events: none;'>
                                       ${options.localizer.AddLink}
                                    </a>`);
                            }
                        }

                    }
                ],
                order: [[OFFERS_COLUMN_INDEX.Name, "asc"]],
                callbacks: {
                    preDrawCallback: this.preDrawCallback
                }
            };
        }
    }

    init(): void {
        this._btnCancelSearch = Utils.getJQueryById(btnCancelSearchId);
        this._filterGame = new MultiSelectApi('filterGame');
        this._filterCurrency = new MultiSelectApi('filterCurrency');

        // cancel search click -> reset filter row values
        this._btnCancelSearch.on('click', this.cancelSearch);
        super.init();
    }

    private addGame(configurationId: number) {
        var urlPost = this._optionUrl;
        var table = this._table;
        var assignedGamesTable = Utils.getJQueryById('tableAssignedGames').DataTable();
        var statusMessage = Utils.getJQueryById("statusMessageWrapper");
        var spinValue = Utils.getJQueryById(`#comboSpinValue${configurationId} option:selected`).val();
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { configurationId: configurationId, spinValue: spinValue },
            success: function (data) {
                statusMessage.html(data);
                StatusMessageHelper.initValidator();
                StatusMessageHelper.initSatusMessage();
                table.draw();
                assignedGamesTable.draw();
            }
        });
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterGame.selectAll();
        this._filterCurrency.selectAll();
    }

    private preDrawCallback(datatable: DatatableApi): any {
        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
        datatable.columns(OFFERS_COLUMN_INDEX.Name).search(filterGame);

        var filterCurrency = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
        datatable.columns(OFFERS_COLUMN_INDEX.Currency).search(filterCurrency);

        return true;
    }

}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/FreeRoundCampaigns/GamesSelectionPage.ts
 **/